import baseEditForm from 'formiojs/components/_classes/component/Component.form';

import MultipleCheckboxesValidation from 'formiojs/components/selectboxes/editForm/SelectBoxes.edit.validation';
import MultipleCheckboxesData from 'formiojs/components/radio/editForm/Radio.edit.data';
import MultipleCheckboxesDisplay from 'formiojs/components/radio/editForm/Radio.edit.display';

export default (...extend) => baseEditForm(
  [
    {
      key: 'display',
      components: MultipleCheckboxesDisplay,
    },
    {
      key: 'data',
      components: MultipleCheckboxesData,
    },
    {
      key: 'validation',
      components: MultipleCheckboxesValidation,
    },
    {
      key: 'addons',
      ignore: true,
    },
    {
      label: 'Custom',
      key: 'custom',
      components: [
        {
          weight: 50,
          type: 'checkbox',
          label: 'Hide Custom Label',
          tooltip:
              'Hide the label (title, if no label) of this component. This allows you to show/hide the custom label when it is rendered.',
          key: 'hideCustomLabel',
          input: true,
        },
      ],
    },
    {
      label: 'Review',
      key: 'review',
      components: [
        {
          weight: 50,
          type: 'checkbox',
          label: 'Use Custom Label',
          tooltip:
              'Use custom label for this component on the review page.',
          key: 'useReviewLabel',
          input: true,
        },
        {
          weight: 100,
          type: 'textfield',
          label: 'Review Page Label',
          key: 'reviewLabel',
          input: true,
        },
      ],
    },
  ],
  ...extend,
);
